import React from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import RetroButton from "../retro/button/retro-button.component";
import { isDocumentId } from "../stations/station-folders";
import "./station-item.styles.scss";

export default function StationItem({ data, spaceId }) {
  const activeSpaceId = useSelector((state) => state.history.spaceId);
  // Sidebar passes its workspace; other callers keep the original Redux fallback.
  const targetSpaceId = spaceId || activeSpaceId;
  const ready = isDocumentId(targetSpaceId) && isDocumentId(data?.stationId);
  const content = (
    <RetroButton disabled={!ready}>
      <div className="EmojiIcon">{data?.emojicon}</div>
      <span className="stationItem__name">{data?.name}</span>
    </RetroButton>
  );
  return (
    <div className="stationItem">
      {ready ? <Link to={`/s/${targetSpaceId}/e/${data.stationId}/b`}>{content}</Link> : content}
    </div>
  );
}
